import React, { useState, useEffect } from "react";
import * as Accordion from "@radix-ui/react-accordion";
import { useLocation } from "react-router-dom";

import { text } from "../text";
import { utils } from "../utils";
import { hooks } from "../hooks";
import { svg } from "../assets/svg";
import { theme } from "../constants";
import { components } from "../components";

const FAQData = [
  {
    id: 1,
    title: "How can I book a PG or rental property?",
    content:
      'You can browse listings, select a preferred property, and click on the "Book Now" button. Follow the steps to complete your booking or get in touch with the owner or property manager for more details.',
  },
  {
    id: 2,
    title: "Are there any booking charges or service fees?",
    content:
      "Some properties may include a nominal service fee. This will be clearly mentioned during the booking process. We do not charge hidden fees.",
  },
  {
    id: 3,
    title: "Is the rent refundable if I cancel?",
    content:
      "Refunds are subject to the cancellation policy of each property. Please review the specific refund terms listed on the property page before booking.",
  },
  {
    id: 4,
    title: "Are food and utilities included in the rent?",
    content:
      "This varies by property. Some PGs include meals and utilities (electricity, Wi-Fi, water) in the rent. Check the amenities section of the listing for detailed information.",
  },
  {
    id: 5,
    title: "Can I visit the property before booking?",
    content:
      "Yes, you can visit the property before booking. Please contact the owner or property manager to arrange a convenient time for the visit.",
  },
  {
    id: 6,
    title: "How do I pay rent every month?",
    content:
      "Rent payments can be made online through our platform using UPI, debit/credit cards, net banking, or wallet options. Automatic monthly payment reminders are sent for your convenience.",
  },
  // {
  //   id: 7,
  //   title: 'Is there a minimum stay duration?',
  //   content:
  //     'Minimum stay durations vary by property. Some allow weekly bookings, while others require at least 1 to 3 months of stay. Check the listing details for specifics.',
  // },
  // {
  //   id: 8,
  //   title: 'Are there any rules I need to follow while staying?',
  //   content:
  //     'Yes, each PG or rental may have its own house rules regarding visitors, smoking, quiet hours, etc. These will be mentioned in the listing and must be followed during your stay.',
  // },
  // {
  //   id: 9,
  //   title: 'How do I raise a complaint or support request?',
  //   content:
  //     'You can reach out to our support team through the "Help & Support" section in your dashboard. We aim to resolve all queries and complaints within 24 hours.',
  // },
];

const menu = [
  {
    id: 1,
    title: "Getting started",
    icon: require("../assets/other/06.png"),
    url: "/home",
  },
  {
    id: 5,
    title: "Serach",
    icon: require("../assets/other/09.png"),
    url: "/onbording5",
  },
  // {
  //   id: 2,
  //   title: 'DashBoard',
  //   icon: require('../assets/other/09.png'),
  //   url: '/tab-navigator',
  // },
  // {
  //   id: 3,
  //   title: 'Purchase',
  //   icon: require('../assets/other/10.png'),
  //   url: '',
  // },
  // {
  //   id: 4,
  //   title: 'Course Taking',
  //   icon: require('../assets/other/11.png'),
  //   url: '',
  // },
];

export const HelpAndSupport: React.FC<{ faqData?: any[] }> = ({
  faqData = [],
}) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const navigate = hooks.useNavigate();
  const [openItem, setOpenItem] = useState<string | null>(null);

  useEffect(() => {
    setTimeout(() => {
      window.scroll({ top: -1, left: 0, behavior: "smooth" });
    }, 10);
  }, [pathname]);

  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header title="Help & Support" goBack={true} />;
  };

  const accordianData = faqData?.length > 0 ? faqData : FAQData;
  const isHelpSupportPage = pathname.includes("help-and-support");

  const renderContent = (): JSX.Element => {
    return (
      <main
        className="container"
        style={{
          paddingBottom: 20,
          paddingTop: isHelpSupportPage ? "85px" : "0px",
          // border: "2px solid red",
        }}
      >
        <Accordion.Root
          type="single"
          collapsible={true}
          style={{ marginTop: 10 }}
        >
          {accordianData?.map((item: any, index) => {
            const isOpen = openItem === item.id;
            return (
              <Accordion.Item
                key={item.id}
                value={item.id}
                className="custom-block"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  marginBottom: 8,
                }}
                onClick={() => setOpenItem(isOpen ? null : item.id)}
              >
                <Accordion.Trigger
                  style={{
                    flexDirection: "column",
                    width: "100%",
                    display: "flex",
                    padding: "18px 20px 18px 20px",
                    ...utils.rowCenterSpcBtw(),
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: theme.colors.transparent,
                  }}
                >
                  <text.H6 numberOfLines={1} style={{ marginRight: 20 }}>
                    {item.title}
                  </text.H6>
                  <div style={{ width: "8px" }}>
                    {isOpen ? <svg.OpenSvg /> : <svg.CloseSvg />}
                  </div>
                </Accordion.Trigger>
                <Accordion.Content style={{ padding: "0px 20px 20px 20px" }}>
                  <text.T16>{item.content}</text.T16>
                  {item.lists?.length && (
                    <ul
                      style={{
                        paddingLeft: 20,
                        marginTop: 8,
                        listStyle: "disc",
                      }}
                    >
                      {item.lists.map((li: string, i: number) => (
                        <li key={i}>
                          <text.T16>{li}</text.T16>
                        </li>
                      ))}
                    </ul>
                  )}

                  {item.secondContent && (
                    <text.T16
                      style={{
                        display: "block",
                        marginTop: 8,
                      }}
                    >
                      {item.secondContent}
                    </text.T16>
                  )}
                </Accordion.Content>
              </Accordion.Item>
            );
          })}
        </Accordion.Root>
        <div
          style={{
            marginTop: 24,
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 15,
          }}
        >
          {/* {menu.map((item, index) => {
            return (
              <div
                style={{
                  width: 'calc(50% - 7.5px)',
                  padding: '30px 0 22px 0',
                  borderRadius: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'pointer',
                  userSelect: 'none',
                  position: 'relative',
                  overflow: 'hidden',
                  backgroundColor:
                    index === 0
                      ? '#ABC9FB'
                      : index === 1
                      ? '#FE9BB3'
                      : index === 2
                      ? '#54DAE2'
                      : index === 3
                      ? '#BEA1FE'
                      : '#D3F9F9',
                }}
                key={item.id}
                onClick={() => {
                  navigate(item.url);
                }}
              >
                <img
                  src={require('../assets/other/08.png')}
                  alt='arrow'
                  style={{
                    width: '100%',
                    height: 'auto',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 1,
                  }}
                />
                <img
                  src={item.icon}
                  alt={item.title}
                  style={{
                    width: utils.clcPercentage(160, 50),
                    height: 'auto',
                    marginBottom: 14,
                    zIndex: 2,
                  }}
                />
                <text.H5
                  style={{
                    color: theme.colors.white,
                    textTransform: 'capitalize',
                    zIndex: 2,
                  }}
                  numberOfLines={1}
                >
                  {item.title}
                </text.H5>
              </div>
            );
          })} */}
        </div>
      </main>
    );
  };

  return (
    <>
      {isHelpSupportPage && renderHeader()}
      {renderContent()}
    </>
  );
};

// import React, {useState, useEffect} from 'react';
// import * as Accordion from '@radix-ui/react-accordion';
// import {useLocation} from 'react-router-dom';

// import {text} from '../text';
// import {utils} from '../utils';
// import {hooks} from '../hooks';
// import {svg} from '../assets/svg';
// import {theme} from '../constants';
// import {components} from '../components';

// const FAQData = [
//   {
//     id: 1,
//     title: 'How do I send a wire transfer?',
//     content:
//       'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
//   {
//     id: 2,
//     title: 'Is there any fee for receiving a wire transfer?',
//     content:
//       'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
//   {
//     id: 3,
//     title: 'How does the identification code process work?',
//     content:
//       'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
//   {
//     id: 4,
//     title: 'Does Fingerprint login work for all devices?',
//     content:
//       'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
//   {
//     id: 5,
//     title: 'How to send an invoice?',
//     content:
//       'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//   },
// ];

// const menu = [
//   {
//     id: 1,
//     title: 'Getting started',
//     icon: require('../assets/other/06.png'),
//     url: '',
//   },
//   {
//     id: 2,
//     title: 'profile',
//     icon: require('../assets/other/09.png'),
//     url: '/tab-navigator',
//   },
//   {
//     id: 3,
//     title: 'Purchase',
//     icon: require('../assets/other/10.png'),
//     url: '',
//   },
//   {
//     id: 4,
//     title: 'Course Taking',
//     icon: require('../assets/other/11.png'),
//     url: '',
//   },
// ];

// export const HelpAndSupport: React.FC = () => {
//   const {pathname} = useLocation();

//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };

//     scrollToTop();
//   }, [pathname]);

//   const navigate = hooks.useNavigate();
//   const [openItem, setOpenItem] = useState<string | null>(null);

//   useEffect(() => {
//     setTimeout(() => {
//       window.scroll({top: -1, left: 0, behavior: 'smooth'});
//     }, 10);
//   }, [pathname]);

//   const renderImageBackground = (): JSX.Element => {
//     return <components.Background version={1} />;
//   };

//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         title='Help & Support'
//         goBack={true}
//       />
//     );
//   };

//   const renderContent = (): JSX.Element => {
//     return (
//       <main
//         className='container'
//         style={{paddingBottom: 20}}
//       >
//         <Accordion.Root
//           type='single'
//           collapsible={true}
//           style={{marginTop: 10}}
//         >
//           {FAQData?.map((item: any, index) => {
//             const isOpen = openItem === item.id;
//             return (
//               <Accordion.Item
//                 key={item.id}
//                 value={item.id}
//                 className='custom-block'
//                 style={{
//                   backgroundColor: 'rgba(255, 255, 255, 0.5)',
//                   marginBottom: 6,
//                 }}
//                 onClick={() => setOpenItem(isOpen ? null : item.id)}
//               >
//                 <Accordion.Trigger
//                   style={{
//                     flexDirection: 'column',
//                     width: '100%',
//                     display: 'flex',
//                     padding: '18px 20px 18px 20px',
//                     ...utils.rowCenterSpcBtw(),
//                     border: 'none',
//                     cursor: 'pointer',
//                     backgroundColor: theme.colors.transparent,
//                   }}
//                 >
//                   <text.H6
//                     numberOfLines={1}
//                     style={{marginRight: 20}}
//                   >
//                     {item.title}
//                   </text.H6>
//                   {isOpen ? <svg.OpenSvg /> : <svg.CloseSvg />}
//                 </Accordion.Trigger>
//                 <Accordion.Content style={{padding: '0px 20px 20px 20px'}}>
//                   <text.T16>{item.content}</text.T16>
//                 </Accordion.Content>
//               </Accordion.Item>
//             );
//           })}
//         </Accordion.Root>
//         <div
//           style={{
//             marginTop: 24,
//             display: 'flex',
//             flexDirection: 'row',
//             flexWrap: 'wrap',
//             gap: 15,
//           }}
//         >
//           {menu.map((item, index) => {
//             return (
//               <div
//                 style={{
//                   width: 'calc(50% - 7.5px)',
//                   padding: '30px 0 22px 0',
//                   borderRadius: 10,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   cursor: 'pointer',
//                   userSelect: 'none',
//                   position: 'relative',
//                   overflow: 'hidden',
//                   backgroundColor:
//                     index === 0
//                       ? '#ABC9FB'
//                       : index === 1
//                       ? '#FE9BB3'
//                       : index === 2
//                       ? '#54DAE2'
//                       : index === 3
//                       ? '#BEA1FE'
//                       : '#D3F9F9',
//                 }}
//                 key={item.id}
//                 onClick={() => {
//                   navigate(item.url);
//                 }}
//               >
//                 <img
//                   src={require('../assets/other/08.png')}
//                   alt='arrow'
//                   style={{
//                     width: '100%',
//                     height: 'auto',
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     zIndex: 1,
//                   }}
//                 />
//                 <img
//                   src={item.icon}
//                   alt={item.title}
//                   style={{
//                     width: utils.clcPercentage(160, 50),
//                     height: 'auto',
//                     marginBottom: 14,
//                     zIndex: 2,
//                   }}
//                 />
//                 <text.H5
//                   style={{
//                     color: theme.colors.white,
//                     textTransform: 'capitalize',
//                     zIndex: 2,
//                   }}
//                   numberOfLines={1}
//                 >
//                   {item.title}
//                 </text.H5>
//               </div>
//             );
//           })}
//         </div>
//       </main>
//     );
//   };

//   return (
//     <>

//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };
